import { API_ROUTE_ADMIN_REPORTS_SETUP_EXPORT } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportSetupExportSettingsTypeOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getSetupExportSettings = () =>
  get<ReportSetupExportSettingsTypeOriginal>(
    API_ROUTE_ADMIN_REPORTS_SETUP_EXPORT,
    IS_NEW_BACKEND_API
  )
